module.exports = __webpack_public_path__ + "img/KFC Double .d71bcbc1.png";